import { Fragment, ReactNode } from 'react'

export const formatTextWithLineBreaks = (text?: string | null): ReactNode => {
  if (!text) return null
  const parts = text.split(/<br\/?>/i)
  if (parts.length === 1) return text

  return parts.map((part, index) => (
    <Fragment key={index}>
      {part}
      {index < parts.length - 1 && <br />}
    </Fragment>
  ))
}
